import { Col, SelectField } from '@/components';
import type { ProjectSearchFormType } from '@/features/search/_models/projects-search';
import { shouldShowIndicatorTerm } from '@/features/search/_utils/activity-indicator-conditions';
import {
  IndicatorTermModifier,
  indicatorTermEnum,
} from '@/features/search/_utils/enum';
import { COL_MIN_WIDTH } from '@/features/search/_utils/projects-search';
import type { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

export const ActivityIndicatorTermColField: FC = () => {
  const { t } = useTranslation();
  const {
    control,
    formState: { errors },
    watch,
  } = useFormContext<ProjectSearchFormType>();

  const [indicatorType, hasOnlyQualitativeIndicator] = watch([
    'indicatorType',
    'hasOnlyQualitativeIndicator',
  ]);

  const enabled = shouldShowIndicatorTerm(
    indicatorType,
    hasOnlyQualitativeIndicator,
  );

  return (
    <Col span={4} style={{ minWidth: COL_MIN_WIDTH.basic }}>
      <SelectField
        name="indicatorTerm"
        label={t('term')}
        control={control}
        errors={errors}
        options={indicatorTermEnum.options.map((value) => ({
          value,
          label: IndicatorTermModifier[value],
        }))}
        disabled={!enabled}
      />
    </Col>
  );
};
